import { CHAIN_DATA_MAPPING } from './constants';
import { ChainData, ChainId } from './types';

export const getChainData = (chainId: ChainId): ChainData => {
  return CHAIN_DATA_MAPPING[chainId];
};

export const formatAccount = (account?: string | null) =>
  account ? `${account.substring(0, 6)}...${account.slice(-4)}` : undefined;
